export const ReferralCodeCookieKey = 'referralCode'
